export default __webpack_public_path__ + "static/media/dummy-microsoft-single.0cad1123.png";